// components/ui/modal/ModalBody.js
export default function ModalBody({ className = "", children }) {
    return (
        <div className={`modal-body tw-relative tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-flex-col sm:tw-flex-row ${className}`}>
            {children}
        </div>
    );
}